<app-dialog
  [config]="data.config"
  (actionButtonClicked)="onFormSubmit($event)"
>
  <ng-container dialog-process-in-progress>
    <app-create-order (complete)="completed($event)"
                      [orderType]="data.orderType" [symbol]="data.productSymbol"></app-create-order>
  </ng-container>
</app-dialog>
